
export default {
  props: {
    tags: { type: Array, required: false, default: () => [] }
  }
}
